// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"0ed8727b703a2edd5cbc","678":"319e12679d24919d1163","883":"cdbc259ee9bea554fac1"}[chunkId] + ".js";
};